"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var Amplitude_1 = require("./Amplitude");
exports.LogOnMount = function (props) {
    var logEvent = Amplitude_1.useAmplitude(undefined, props.instanceName).logEvent;
    React.useEffect(function () {
        logEvent(props.eventType, props.eventProperties);
    }, []);
    return props.children || null;
};
exports.LogOnMount.propTypes = {
    eventProperties: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    eventType: PropTypes.string.isRequired,
    instanceName: PropTypes.string,
};
